import { render, staticRenderFns } from "./MultasAdministrativas.vue?vue&type=template&id=28996df4&scoped=true"
import script from "./MultasAdministrativas.vue?vue&type=script&lang=js"
export * from "./MultasAdministrativas.vue?vue&type=script&lang=js"
import style0 from "./MultasAdministrativas.vue?vue&type=style&index=0&id=28996df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28996df4",
  null
  
)

export default component.exports